import { render, staticRenderFns } from "./My-Performance-KRA.vue?vue&type=template&id=188e4126&"
import script from "./My-Performance-KRA.vue?vue&type=script&lang=js&"
export * from "./My-Performance-KRA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports